import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  badge: {
    fontFamily: 'BentonSansBold',
    fontSize: '14px !important',
    height: '22px !important',
    paddingTop: '6px !important',
    margin: '20px 0px 0px 20px !important',
    textAlign: 'center',
    maxWidth: '85px'
  },
  card: {
    borderBottomLeftRadius: '0 !important',
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardBody: {
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between !important'
  },
  carousel: ({ hasMultipleActions }) => ({
    '&:after': {
      content: "' '",
      display: !hasMultipleActions && 'none',
      minWidth: '20px'
    },
    padding: '15px'
  }),
  actionCarousel: {
    padding: '0px 35px 35px 15px'
  },
  mediaContainer: {
    marginBottom: '15px'
  },
  subheader: {
    display: 'flex',
    flexDirection: 'row !important',
    justifyContent: 'flex-start !important'
  },
  title: {
    fontWeight: '600 !important',
    textDecoration: ({ variant }) => variant === 'invalid' && 'line-through'
  },
  '@media (max-width: 667px)': {
    cardBody: {
      padding: '6px 16px 10px !important'
    },
    imageWrapper: {
      paddingLeft: '15px'
    }
  }
})

export default useStyles
